import { toInteger } from 'lodash';

import { DISCOUNT_MULTIPLE_COURSE } from './constants';

export const getMultipleCourseDiscount = (numOfUniqueEnrolledCourses: number): number => {
  if (numOfUniqueEnrolledCourses <= 1) return 0;

  if (numOfUniqueEnrolledCourses in Object.keys(DISCOUNT_MULTIPLE_COURSE)) {
    return DISCOUNT_MULTIPLE_COURSE[numOfUniqueEnrolledCourses];
  }
  // Return the highest multiple course discount available
  return DISCOUNT_MULTIPLE_COURSE[
    Math.max(
      ...(Object.keys(DISCOUNT_MULTIPLE_COURSE).map((x) => toInteger(x))),
    )
  ];
};
